// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-gitlab"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6 2H5.5L1.5 14L12 22L22.5 14L18.5 2H18L15.5 9.33333H8.5L6 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6 2H5.5L1.5 14L12 22L22.5 14L18.5 2H18L15.5 9.33333H8.5L6 2Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-gitlab')
export default class LogoGitlabIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-gitlab',
    }
  }
}
